export default {
  shipping: "shipping",
  delivery: "delivery",
  billing: "billing",
  collection: "collection",
  dropOff: "drop_off",
};
